/**
 * @generated SignedSource<<51b223fa51584900a6dd451ac3dee735>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type accountsPage_Query$variables = Record<PropertyKey, never>;
export type accountsPage_Query$data = {
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly nickname: string;
    readonly number: string;
  }>;
  readonly sourcingAccounts: ReadonlyArray<{
    readonly acctType: string | null | undefined;
    readonly bankAccount: {
      readonly id: string;
      readonly nickname: string;
      readonly number: string;
    } | null | undefined;
    readonly keptSeparate: boolean;
    readonly merged: boolean;
    readonly name: string;
    readonly nearTwinCount: number;
    readonly qboId: string;
    readonly run: {
      readonly currentObject: string | null | undefined;
      readonly errorMessage: string | null | undefined;
      readonly finishedAt: any | null | undefined;
      readonly jobId: number;
      readonly kind: string;
      readonly outcome: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
      readonly params: any;
      readonly phase: string | null | undefined;
      readonly rowsProcessed: number;
      readonly rowsTotal: number | null | undefined;
      readonly status: string;
      readonly unit: string | null | undefined;
    } | null | undefined;
    readonly suggestion: {
      readonly id: string;
      readonly nickname: string;
      readonly number: string;
    } | null | undefined;
    readonly suggestionReasons: ReadonlyArray<string>;
  }>;
};
export type accountsPage_Query = {
  response: accountsPage_Query$data;
  variables: accountsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acctType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merged",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keptSeparate",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v8 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccount",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "suggestion",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suggestionReasons",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nearTwinCount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "run",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "params",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentObject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowsProcessed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowsTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountJobOutcome",
      "kind": "LinkedField",
      "name": "outcome",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingQboAccount",
        "kind": "LinkedField",
        "name": "sourcingAccounts",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      (v14/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accountsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingQboAccount",
        "kind": "LinkedField",
        "name": "sourcingAccounts",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v14/*: any*/)
    ]
  },
  "params": {
    "cacheID": "52216ee883cc43fda3064409ce94ba11",
    "id": null,
    "metadata": {},
    "name": "accountsPage_Query",
    "operationKind": "query",
    "text": "query accountsPage_Query {\n  sourcingAccounts {\n    qboId\n    name\n    acctType\n    merged\n    keptSeparate\n    bankAccount {\n      id\n      nickname\n      number\n    }\n    suggestion {\n      id\n      nickname\n      number\n    }\n    suggestionReasons\n    nearTwinCount\n    run {\n      jobId\n      kind\n      params\n      status\n      phase\n      currentObject\n      rowsProcessed\n      rowsTotal\n      unit\n      errorMessage\n      finishedAt\n      outcome {\n        key\n        value\n      }\n    }\n    id\n  }\n  bankAccounts {\n    id\n    nickname\n    number\n    last4\n  }\n}\n"
  }
};
})();

(node as any).hash = "42870e1896e5ac2501d4641677cd3d26";

export default node;
